import React from "react";
import { motion } from "framer-motion";
import "../BusinessConsulting.css";
import { Link } from "react-router-dom";
import ERPServices from "../Pages/ErpServices";

const ErpConsulting = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  const fadeInLeft = {
    hidden: { opacity: 0, x: -60 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  const fadeInRight = {
    hidden: { opacity: 0, x: 60 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const staggerItem = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <>
      <div
        className="container-fluid p-0 banner-section"
        style={{ backgroundImage: "url('img/erp.jpg')" }}
      >
        <div className="overlay"></div>
        <div className="row">
          <div className="col-md-12 mt-5 text-white text-center">
            <h1 className="pt-5 mt-5 "> ERP Consulting</h1>
            <nav>
              <ol className="breadcrumb justify-content-center bg-transparent">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-white text-decoration-none">
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                   ERP Consulting
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="container my-5 py-5">
        <div className="row align-items-center">
          <motion.div
            className="col-12 col-md-6 mb-4 mb-md-0"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeInLeft}
          >
            <motion.img
              src="img/erp-management-software.webp"
              alt="ERP Management Software"
              className="img-fluid rounded shadow"
              whileHover={{ scale: 1.03 }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>

          <motion.div
            className="col-12 col-md-6"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeInRight}
          >
            <h1 className="fw-bold">
              ERP CONSULTING WITH <span className="text-primary">DigiOpen</span>
            </h1>
            <p style={{ fontSize: "18px" }}>
         At DigiOpen Services, we provide ERP consultation to customers, including professional advisory
services such as software selection, implementation, and optimisation.

These services help streamline business processes, improve efficiency, reduce costs, and optimise
operational processes. We manage system, strategy, and training. As ERP Project Management
consultants, we lead from the front and manage the entire ERP project end-to-end. This includes
planning, selection, and implementation.

ERP consulting is a structured approach to evaluating business processes, identifying system gaps,
and defining a roadmap for ERP adoption. Services include process mapping, fit-gap analysis
(comparing needs to software capability), vendor selection, and implementation.
            </p>
            {/* <motion.ul
              className="erp-bullet-points"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              <motion.li variants={staggerItem}>
                <strong>ERP Consulting helps clients build more adaptive networks by:</strong> 
              </motion.li>
              <motion.li variants={staggerItem}>
                <strong>Delivering networking technology </strong> 
              </motion.li>
              <motion.li variants={staggerItem}>
                <strong>Partnering with clients </strong> 
              </motion.li>
              <motion.li variants={staggerItem}>
                <strong>Strategically integrating hardware.</strong> 
              </motion.li>
              <motion.li variants={staggerItem}>
                <strong>We specialise in automating accounting, supply chain, inventory, risk, and project management.</strong> 
              </motion.li>
            </motion.ul> */}



<strong>ERP Consulting helps clients build more adaptive networks by:</strong>
                <ul className="list-style-one d-flex flex-wrap">
              <li className="col-12 mb-2">
               Delivering networking technology
              </li>
              <li className="col-12 mb-2">Enterprise Mobility Solutions </li>
              <li className="col-12 mb-2">
               Partnering with clients
              </li>
              <li className="col-12 mb-2">
                Strategically integrating hardware.
              </li>
              <li className="col-12 mb-2">
               We specialise in automating accounting, supply chain, inventory, risk, and project management.
              </li>
             
            </ul>
          </motion.div>
        </div>
      </div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInUp}
      >
        <ERPServices />
      </motion.div>
    </>
  );
};

export default ErpConsulting;